import commonMixin from './mixins/commom'

export default {
    mixins: [commonMixin],
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        showDialog: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val)
            },
        },
    },
}
